// extracted by mini-css-extract-plugin
export default {"formGroup":"ForgotPassword_formGroup__jY1-H","textColor":"ForgotPassword_textColor__cuuZV","inputBox":"ForgotPassword_inputBox__SJX+q","button":"ForgotPassword_button__+OTEK"};